// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + ".js?v=" + {"1680":"0e643f8d6c3f292cbd77","2007":"2106ede95e6119e2b9a8","9152":"0d6e6ad9db6c53cb1a0a"}[chunkId] + "";
};